export interface CircleAnnotation {
  type: 'circle';
  x: string;
  y: string;
  label: string;
}

export interface HighlightAnnotation {
  type: 'highlight';
  x: string;
  y: string;
  width: string;
  height: string;
}

export interface ArrowAnnotation {
  type: 'arrow';
  x: string;
  y: string;
  direction: 'up' | 'down' | 'left' | 'right';
}

export type Annotation = CircleAnnotation | HighlightAnnotation | ArrowAnnotation;

const arrowBorders: Record<string, string> = {
  up: 'border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[8px] border-b-primary',
  down: 'border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-primary',
  left: 'border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-r-[8px] border-r-primary',
  right: 'border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[8px] border-l-primary',
};

export function AnnotationOverlay({ annotations }: { annotations: Annotation[] }) {
  return (
    <>
      {annotations.map((a, i) => {
        if (a.type === 'circle') {
          return (
            <div
              key={i}
              className="absolute w-6 h-6 rounded-full bg-primary text-white font-bold text-xs flex items-center justify-center -translate-x-1/2 -translate-y-1/2 z-10 pointer-events-none"
              style={{ left: a.x, top: a.y }}
            >
              {a.label}
            </div>
          );
        }

        if (a.type === 'highlight') {
          return (
            <div
              key={i}
              className="absolute ring-2 ring-primary rounded-lg z-10 pointer-events-none"
              style={{ left: a.x, top: a.y, width: a.width, height: a.height }}
            />
          );
        }

        return (
          <div
            key={i}
            className={`absolute w-0 h-0 -translate-x-1/2 -translate-y-1/2 z-10 pointer-events-none ${arrowBorders[a.direction]}`}
            style={{ left: a.x, top: a.y }}
          />
        );
      })}
    </>
  );
}
